import { Modal as StaticModal } from 'antd';
import type { HookAPI } from 'antd/es/modal/useModal';

/**
 * ConfigProvider 테마가 적용된 확인 창(modal.confirm)으로 연결하는 얇은 유틸 — appMessage 와 같은 방식(감사 card-controltower#538).
 * 정적 `Modal.confirm` 은 React 트리 밖에 그려져 다크 모드 테마 · 컨텍스트(useThemeTokens)를 못 받는다. `<App>` 안에서 만든
 * 인스턴스를 App.tsx 의 브리지가 등록하고, 없으면(테스트 · 마운트 전) 정적 API 로 폴백한다.
 */
type ConfirmApi = Pick<HookAPI, 'confirm'>;
let instance: ConfirmApi | null = null;

export const setAppModalInstance = (next: ConfirmApi | null): void => {
  instance = next;
};

export const appModal: ConfirmApi = {
  confirm: (config) => (instance ?? (StaticModal as unknown as ConfirmApi)).confirm(config),
};
